var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-277.000000, -170.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6.36333334 C4.42333333,4.9 2.32,4 0,4 L0,11.3333333 C2.32,11.3333333 4.42333333,12.2333333 6,13.6966667 C7.57666667,12.2333333 9.68,11.3333333 12,11.3333333 L12,4 C9.68,4 7.57666667,4.9 6,6.36333334 Z M6,4 C7.10333333,4 8,3.10333333 8,2 C8,0.896666672 7.10333333,0 6,0 C4.89666667,0 4,0.896666672 4,2 C4,3.10333333 4.89666667,4 6,4 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.c0c322fe0b6eaeedd53050627494ba9d.svg";
export { ForwardRef as ReactComponent };